<template>
  <div class="project-app-wrapper">
    <div class="left" :class="getClass()">
      <Sidebar v-show="!['ScenarioPlanDetail'].includes(root.$route.name)"/> <!--左侧图标栏-->
      <div class="main-content uranus-scrollbar dark" :class="getClass()" :style="getStyle()">
        <!--中间内容-->
        <router-view />
      </div>
      <div class="menu-icon" v-show="!['ScenarioPlanDetail'].includes(root.$route.name)" @click="handleChangeCollapsed" v-if="showHeader">
        <CaretLeftOutlined v-if="collapsed" />
      <CaretRightOutlined v-else />
      </div>
    </div>
    <div class="right">

    </div>
  </div>
</template>
<script lang="ts" setup>
import Sidebar from '/@/components/scenario/sidebar.vue'
import { getRoot } from '/@/root'
import { useMyStore } from '/@/store'
import { useConnectWebSocket } from '/@/hooks/use-connect-websocket'
import { handleMessage, initMessageHandler } from '/@/utils/websocket-message-handler'
import { computed, onMounted } from 'vue'
import { ELocalStorageKey, ERouterName } from '/@/types'
import cookies from 'vue-cookies'

const root = getRoot()
const store = useMyStore()
const collapsed = computed(() => store.state.collapsed)
const showHeader = computed(() => {
  return store.state.headerVisible
})
// 初始化消息处理器
initMessageHandler(store)

// 监听ws 消息
useConnectWebSocket(handleMessage)

function handleChangeCollapsed () {
  store.commit('SET_COLLAPSED', !collapsed.value)
}

function getClass () {
  let cls = ''
  if (!collapsed.value) cls += ' no-sidebar'
  if (root.$route.path === '/' + ERouterName.SCENARIO_ICON || root.$route.path.indexOf('/scenario-plan-detail') > -1) {
    cls += ' custom'
  }
  return cls
}
function getStyle () {
  const sty = { width: '285px' }
  if (root.$route.path === '/' + ERouterName.SCENARIO_ICON || root.$route.path.indexOf('/scenario-plan-detail') > -1) {
    sty.width = '100%'
  }
  return sty
}
onMounted(() => {
  const token = cookies.get(ELocalStorageKey.Token)
  if (token) {
    if (root.$route.path === '/' + ERouterName.SCENARIO_ICON) {
      root.$router.push(ERouterName.SCENARIO_ICON)
    } else if (root.$route.path === '/' + ERouterName.SCENARIO_PLAN) {
      root.$router.push(ERouterName.SCENARIO_PLAN)
    }
  }
})
</script>
<style lang="scss" scoped>
@use '/@/styles/index.scss' as *;

.project-app-wrapper {
  display: flex;
  transition: width 0.2s ease;
  height: 100%;
  width: 100%;

  .left {
    position: relative;
    transition: width 0.2s ease-in-out;
    &:not(.custom){
    display: flex;
    width: 500px;
    flex: 0 0 335px;
    background-color: #2f2f2f;

    .main-content {
      flex: 1;
      color: $text-white-basic;
      // width: 285px;
    }
  }
  &.custom{
    width: 100%;
    background-color: #2f2f2f;
    display: flex;
    .main-content{
      flex: 1;
    }
  }
  &.no-sidebar .sidebar-container{
    width: 68px;
  }
  .menu-icon{
    width: 30px;
    height: 30px;
    padding: 10px;
    color: #f6f8fa;
    position: fixed;
    top: 15px;
    left: 280px;
    z-index: 1000;
    cursor: pointer;
    background-color: #02274b;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  }

  .right {
    flex-grow: 1;
    position: relative;

    .map-wrapper{
      width: 100%;
      height: 100%;
    }

    .media-wrapper,
    .task-wrapper,
    .device-wrapper {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 400;
      background: #f6f8fa;
    }
  }
}
</style>
